import React from "react";
import { v4 } from "uuid";
import moment from "moment";
import { Grid, Typography } from "@material-ui/core";
import useStyles from "./styles";
import StateLabel from "../../../../../../components/StateLabel";
import { Beneficiary } from "../../../../../../domain/RecurrentPayment";
import { translate as t } from "../../../../../../../infrastructure/translate/localization";
import { MonetaryAmount } from "../../../../../../domain/monetary-amount";
import { parseStateColor } from "../../../../config";

export default function Beneficiaries({
  beneficiaries,
}: {
  beneficiaries: Beneficiary[];
}): JSX.Element {
  const {
    container,
    title,
    containerList,
    beneficiarieContainer,
    nameLabel,
    label,
    dataStyle,
    dataBoldStyle,
    row,
    lineSeparator,
  } = useStyles();

  const configStates = {
    confirm: t("recurrent-payments-section.subscribe"),
    rejected: t("recurrent-payments-section.unsubscribe"),
  };

  return (
    <Grid className={container}>
      <Typography variant="body2" className={title}>
        {t("recurrent-payments-section.added-beneficiaries").toUpperCase()}
      </Typography>
      <Grid container wrap="nowrap" className={containerList}>
        {beneficiaries.map(
          ({ name, state, amount, companyAmount, employeeAmount, date }) => (
            <Grid className={beneficiarieContainer} key={v4()}>
              <Grid container alignItems="center" className={row}>
                <Typography className={nameLabel}>{name}</Typography>
                <Grid className={dataStyle}>
                  <StateLabel
                    text={configStates[state]}
                    color={parseStateColor({ state, isInsurance: true })}
                  />
                </Grid>
              </Grid>
              <Grid className={lineSeparator} />
              <Grid container alignItems="center" className={row}>
                <Typography variant="body2" className={label}>
                  {t("recurrent-payments-section.insurance-amount")}
                </Typography>
                <Typography variant="body2" className={dataBoldStyle}>
                  {`${MonetaryAmount.ofCurrency({
                    amountInCents: amount.amountInCents,
                    currency: amount.currency,
                  }).prettifyMoneyWithoutSymbol()}€/${t(
                    "common-messages.month"
                  )}`}
                </Typography>
              </Grid>
              <Grid container alignItems="center" className={row}>
                <Typography variant="body2" className={label}>
                  {t("recurrent-payments-section.the-company-pays")}
                </Typography>
                <Typography variant="body2" className={dataStyle}>
                  {`${MonetaryAmount.ofCurrency({
                    amountInCents: companyAmount?.amountInCents,
                    currency: companyAmount?.currency,
                  }).prettifyMoneyWithoutSymbol()}€/${t(
                    "common-messages.month"
                  )}`}
                </Typography>
              </Grid>
              <Grid container alignItems="center" className={row}>
                <Typography variant="body2" className={label}>
                  {t("recurrent-payments-section.the-employee-pays")}
                </Typography>
                <Typography variant="body2" className={dataStyle}>
                  {`${MonetaryAmount.ofCurrency({
                    amountInCents: employeeAmount?.amountInCents,
                    currency: employeeAmount?.currency,
                  }).prettifyMoneyWithoutSymbol()}€/${t(
                    "common-messages.month"
                  )}`}
                </Typography>
              </Grid>
              <Grid className={lineSeparator} />
              <Grid container alignItems="center">
                <Typography variant="body2" className={label}>
                  {t("recurrent-payments-section.effect-date")}
                </Typography>
                <Typography variant="body2" className={dataStyle}>
                  {date
                    ? `${moment(date).format("D")} ${moment(date).format(
                        "MMM"
                      )} ${moment(date).format("YYYY")}`
                    : "-"}
                </Typography>
              </Grid>
            </Grid>
          )
        )}
      </Grid>
    </Grid>
  );
}
